import {analytics} from '../analytics';
import {ClientIds, Roles} from '../api/generated/enums';
import {Env} from '../config/env-vars';
import {notify} from '../hooks/use-subscription';
import {User} from '../types';
import {logger} from '../utils/logger';
import {UserManager, Log, User as OidcUser} from 'oidc-client-ts';

Log.setLevel(Log.INFO);
Log.setLogger(logger('oidc', {namespace: 'oidc-client'}));

export const userManager = new UserManager({
  client_id: ClientIds.web,
  authority: Env.apiBaseUrl || '',
  response_type: 'code',
  scope: `openid profile mmvalve.arf.permissions mmvalve.arf.api`,
  redirect_uri: `${Env.appRoot}/callback`,
  filterProtocolClaims: true,
  post_logout_redirect_uri: Env.appRoot,
  silent_redirect_uri: `${Env.appRoot}/silent-refresh.html`,
  loadUserInfo: true,
  monitorSession: true,
});

userManager.events.addSilentRenewError(() => {
  analytics.trackEvent('identity.session-expired');
  notify('session-expired', undefined);
});

userManager.events.addUserSignedOut(async () => {
  await userManager.removeUser();
  window.location.reload();
});

export const getUser = async (): Promise<OidcUser | null> => {
  const user = await userManager.getUser();
  return !user?.expired ? user : null;
};

export const mapOidcUser = (user: OidcUser): User => ({
  id: Number(user.profile.sub),
  name: user.profile.name || '',
  email: user.profile.preferred_username || '',
  permissions: user.profile['permissions'] as string[],
  role: user.profile['role'] as Roles,
});
